import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import api from '../../modules/api';

const EntityContext = createContext();

export function EntityProvider({ children }) {
  const [userData, setUserData] = useState({});
  const [currentEntity, setCurrentEntity] = useState(null);
  const { entityId } = useParams();

  useEffect(() => {
    api.user.getPublicEntities({ ids: [entityId] })
      .then(([entity]) => {
        setCurrentEntity(entity);
      })
      .catch((error) => {
        console.error('Error fetching entity:', error);
      });
  }, [entityId]);

  useEffect(() => {
    if (currentEntity?.userId) {
      api.user.getPublicProfile({ userId: currentEntity.userId })
        .then((user) => {
          setUserData(user);
        })
        .catch((error) => {
          console.error('Error fetching user profile:', error);
        });
    }
  }, [currentEntity?.userId]);

  const entityTypes = useMemo(() => {
    const types = {};
    currentEntity?.edgesAsNodeA.forEach(edge => {
      if (edge.type === 'is an instance of') {
        types[edge.nodeBNode.name] = {
          id: edge.nodeBNode.id,
        };
      }
    });
    return types;
  }, [currentEntity?.edgesAsNodeA])

  const edgesAsNodeAGrouped = useMemo(() => {
    const groupedEdges = {};
    currentEntity?.edgesAsNodeA.forEach(edge => {
      if (!groupedEdges[edge.type]) {
        groupedEdges[edge.type] = [];
      }
      groupedEdges[edge.type].push(edge);
    });
    return groupedEdges;
  }, [currentEntity?.edgesAsNodeA]);

  const edgesAsNodeBGrouped = useMemo(() => {
    const groupedEdges = {};
    currentEntity?.edgesAsNodeB.forEach(edge => {
      if (!groupedEdges[edge.type]) {
        groupedEdges[edge.type] = [];
      }
      groupedEdges[edge.type].push(edge);
    });
    return groupedEdges;
  }, [currentEntity?.edgesAsNodeB]);

  const value = {
    userData,
    currentEntity,
    entityTypes,
    edgesAsNodeAGrouped,
    edgesAsNodeBGrouped,
  };

  console.log('ViewEntity context:', value);

  return (
    <EntityContext.Provider value={value}>
      {children}
    </EntityContext.Provider>
  );
}

export function useEntityContext() {
  const context = useContext(EntityContext);
  if (context === undefined) {
    throw new Error('useEntityContext must be used within a EntityProvider');
  }
  return context;
}
